import { useState } from 'react';
import { Link } from '@bigcommerce/big-design';
import { useCurrency, useOrderProducts } from '../../../../context';
import { updateProducts } from '../../../../store/orderProducts';
import PriceEditPopup from '../PriceEditPopup';

export function PriceFormatter({ salePrice, originalPrice, formatter }) {
	if (isNaN(salePrice) || salePrice === originalPrice)
		return <div>{formatter.format(originalPrice)}</div>;
	return (
		<div className="price-column-styles">
			<span className="sale-or-new-price">
				{formatter.format(salePrice)}
			</span>
			&nbsp;
			<span className="price">{formatter.format(originalPrice)}</span>
		</div>
	);
}

export function PriceEditColumn(product) {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [, dispatchOrderProducts] = useOrderProducts();
	const [currency] = useCurrency();
	const currencyFormatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
		minimumFractionDigits: 2,
	});
	const { new_price, sale_price, price, amount_off } = product;
	const salePrice = Number(new_price || sale_price);

	if (product.is_custom_product) {
		return (
			<>
				<PriceFormatter
					salePrice={salePrice}
					originalPrice={price}
					formatter={currencyFormatter}
				/>
			</>
		);
	} else {
		return (
			<>
				<PriceFormatter
					salePrice={salePrice}
					originalPrice={price}
					formatter={currencyFormatter}
				/>
				<div>{amount_off ? `${amount_off ?? ''}% off` : ''}</div>
				<div>
					<Link
						paddingTop="xxxSmall"
						onClick={() => setModalIsOpen(true)}
					>
						Edit
					</Link>
				</div>
				<PriceEditPopup
					price={price}
					isOpen={modalIsOpen}
					setIsOpen={setModalIsOpen}
					updateOrderProduct={(name, value) =>
						dispatchOrderProducts(
							updateProducts({ ...product, [name]: value }),
						)
					}
				/>
			</>
		);
	}
}
